import { getAppearance, changeAppearance } from "@/api/cms";

export default {
  namespaced: true,
  state: () => ({
    logoURL: "",
    initLogoURL: "",
    defaultLogoURL: "",

    wallpaperURL: "",
    initWallpaperURL: "",
    defaultWallpaperURL: "",

    remark: "",
    initRemark: "",
    defaultRemark: "",

    forumEnabled: false,
    initForumEnabled: false,

    forumLink: "",
    initForumLink: "",

    forumTitle: "",
    initForumTitle: ""
  }),
  getters: {
    hasChanged(state) {
      return (
        state.logoURL !== state.initLogoURL ||
        state.wallpaperURL !== state.initWallpaperURL ||
        state.remark !== state.initRemark ||
        state.forumEnabled !== state.initForumEnabled ||
        state.forumLink !== state.initForumLink ||
        state.forumTitle !== state.initForumTitle
      );
    },
    isDefaultLogoURL(state) {
      return state.logoURL === state.defaultLogoURL;
      // return state.logoURL = "";
    },
    isDefaultWallpaperURL(state) {
      if ((state.defaultWallpaperURL && !state.wallpaperURL) ||
      (!state.wallpaperURL && !state.defaultWallpaperURL)) return true;
      if (state.wallpaperURL && state.defaultWallpaperURL) return state.wallpaperURL === state.defaultWallpaperURL;
      return false;
    },
    isDefaultRemark(state) {
      return state.remark === state.defaultRemark;
    }
  },
  mutations: {
    SET_LOGO_URL(state, value) {
      state.logoURL = value;
    },
    SYNC_LOGO_URL(state, value) {
      console.log(value);
      state.initLogoURL = value;
      state.logoURL = value;
    },
    SET_DEFAULT_LOGO_URL(state, value) {
      console.log(value);
      state.defaultLogoURL = value;
    },
    RESET_LOGO_URL(state) {
      state.logoURL = state.defaultLogoURL;
      // state.logoURL = "";
    },
    SYNC_WALLPAPER_URL(state, value) {
      state.initWallpaperURL = value;
      state.wallpaperURL = value;
    },
    SET_WALLPAPER_URL(state, value) {
      state.wallpaperURL = value;
    },
    SET_DEFAULT_WALLPAPER_URL(state, value) {
      state.defaultWallpaperURL = value;
    },
    RESET_WALLPAPER_URL(state) {
      state.wallpaperURL = state.defaultWallpaperURL;
    },
    SET_REMARK(state, value) {
      state.remark = value;
    },
    SYNC_REMARK(state, value) {
      state.initRemark = value;
    },
    SET_DEFAULT_REMARK(state, value) {
      state.defaultRemark = value;
    },
    RESET_REMARK(state) {
      state.remark = state.defaultRemark;
    },
    SYNC_FORUM_ENABLED(state, value) {
      state.forumEnabled = value;
      state.initForumEnabled = value;
    },
    SET_FORUM_ENABLED(state, value) {
      state.forumEnabled = value;
    },
    SYNC_FORUM_LINK(state, value) {
      state.forumLink = value;
      state.initForumLink = value;
    },
    SET_FORUM_LINK(state, value) {
      state.forumLink = value;
    },
    SYNC_FORUM_TITLE(state, value) {
      state.forumTitle = value;
      state.initForumTitle = value;
    },
    SET_FORUM_TITLE(state, value) {
      state.forumTitle = value;
    }
  },
  actions: {
    getAppearance({ commit }, payload) {
      return getAppearance().then(({ res }) => {
        const data = res.data.data;
        const appearance = data["appearance"];
        const forum = data["forum"];
        const defaults = data["default"];

        if(payload === 1) {
          commit("SYNC_LOGO_URL", appearance?.logo || defaults.logo);
          commit("SET_DEFAULT_LOGO_URL", defaults.logo);

          commit("SYNC_WALLPAPER_URL", appearance?.wallpaper_or_link);
          commit(
            "SET_DEFAULT_WALLPAPER_URL",
            defaults?.wallpaper_or_link || null
          );

          if (appearance?.name) {
            commit("SYNC_REMARK", appearance.name);
            commit("SET_REMARK", appearance.name);
          } else {
            commit("SYNC_REMARK", defaults?.remark);
          }
          commit("SET_DEFAULT_REMARK", defaults?.remark);
        } else {
          if (forum) {
            commit("SYNC_FORUM_ENABLED", !!forum.switch);

            commit("SYNC_FORUM_LINK", forum["wallpaper_or_link"]);

            commit("SYNC_FORUM_TITLE", forum.name);
          } else {
            commit("SYNC_FORUM_ENABLED", false);
          }
        }
      });
    },
    changeAppearance({ state, dispatch }, label) {
      const params = label === 1 ? {
        appearance_name: state.remark,
        logo: state.logoURL,
        wallpaper: state.wallpaperURL,
        form: 'appearance'
      } : {
        switch: state.forumEnabled,
        link: state.forumLink,
        icon_name: state.forumTitle,
        form: 'forum'
      }
      return changeAppearance(params).then(() => {
        return dispatch("getAppearance", label);
      });
    }
  }
};
